export default "__VITE_ASSET__McEl0Mba__"